export const logoImage = "ACARA-logo-fondoblanco.png";